// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"rp-z","breadcrumbForward":"sp-z","breadcrumbBack":"tp-z","selected":"up-z"};